/* Dakol v1: pomiar (plan części 2, sekcje 3.2 i 3.3). Jeden lekki moduł ładowany przez base.js
   (data-component="pomiar" data-load="now"). Zero bibliotek, bez GTM, bez fbq.
   Co robi:
   1. window.dataLayer ze zdarzeniami GA4 (view_item, view_item_list, add_to_cart, begin_checkout, search)
      i zdarzeniami własnymi motywu (dakol_*, generate_lead, zdarzenia asystenta) z window.dakolEvent.
   2. Consent Mode v2: sygnały ad_storage, ad_user_data, ad_personalization, analytics_storage
      z banera zgód Shopify (Customer Privacy API), domyślnie denied, aktualizacja po decyzji klienta.
   3. Opcjonalnie gtag.js w motywie (ustawienie "Ładuj gtag w motywie" + ID GA4 z ustawień motywu).
      Domyślnie wyłączone: GA4 działa przez aplikację Google & YouTube, a zdarzenia własne przekazuje
      piksel własny (docs/pomiar.md). Włączenie obu naraz podwaja liczenie.
      SEO-KOD 17.10 (audyt SEO, poprawka 1): skrypt gtag.js jest pobierany DOPIERO po zgodzie klienta
      (analityka albo marketing) z banera Shopify; przed decyzją nic nie wychodzi z przeglądarki,
      a zdarzenia czekają w dataLayer (gtag odtwarza kolejkę po wczytaniu). Motyw sam nie ładuje żadnych
      pikseli (Facebook, Google Ads, TikTok); piksele z aplikacji Shopify włącza i ogranicza Kamil w panelu.
   Dane wejściowe: JSON #dakol-pomiar (snippet pomiar-dane), atrybuty data-item-* kart (product-card),
   JSON [data-pomiar-cart] (snippet pomiar-koszyk), zdarzenie dakol:cart:add z odpowiedzią /cart/add.js. */

const d = document;
const cfg = (() => {
  try { return JSON.parse(d.getElementById('dakol-pomiar')?.textContent || '{}'); } catch (err) { return {}; }
})();
const currency = () => cfg.currency || window.Shopify?.currency?.active || 'PLN';
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0; };
const str = (v, max = 100) => (v === null || v === undefined ? undefined : String(v).slice(0, max));

window.dataLayer = window.dataLayer || [];
const dl = window.dataLayer;
const log = [];
const DENIED = { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied' };
const consent = { ...DENIED, decided: false };
const useGtag = Boolean(cfg.gtag_w_motywie && cfg.ga4_id);

/* 3. gtag w motywie: consent default i kolejka poleceń od razu, sam skrypt gtag.js dopiero po zgodzie
   (tryb podstawowy Consent Mode v2: bez zgody zero żądań do Google; po zgodzie gtag odtwarza kolejkę z dataLayer). */
let gtagLoaded = false;
function loadGtag() {
  if (!useGtag || gtagLoaded) return;
  gtagLoaded = true;
  const s = d.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(cfg.ga4_id)}`;
  d.head.appendChild(s);
}
if (useGtag) {
  window.gtag = window.gtag || function gtag() { dl.push(arguments); };
  window.gtag('consent', 'default', { ...DENIED, wait_for_update: 500 });
  window.gtag('set', 'ads_data_redaction', true);
  window.gtag('js', new Date());
  window.gtag('config', cfg.ga4_id, cfg.debug ? { debug_mode: true } : {});
}

/* Wysyłka: gtag('event') sam dopisuje do dataLayer; bez gtag dopisujemy obiekt w konwencji GA4/GTM. */
function send(name, params = {}) {
  const clean = {};
  Object.keys(params).forEach((k) => { if (params[k] !== undefined && params[k] !== null && params[k] !== '') clean[k] = params[k]; });
  const rec = { event: name, params: clean, consent: { ...consent }, ts: Date.now() };
  log.push(rec);
  if (log.length > 50) log.shift();
  if (useGtag) window.gtag('event', name, clean);
  else if (clean.items) { dl.push({ ecommerce: null }); dl.push({ event: name, ecommerce: clean }); }
  else dl.push({ event: name, ...clean });
  if (cfg.debug) console.debug('[pomiar]', name, clean, rec.consent); // eslint-disable-line no-console
  d.dispatchEvent(new CustomEvent('dakol:pomiar', { detail: rec }));
  return rec;
}

/* 2. Consent Mode v2 z Customer Privacy API Shopify. */
function applyConsent(api) {
  if (!api) return;
  let marketing = false;
  let analytics = false;
  try { marketing = api.marketingAllowed(); analytics = api.analyticsProcessingAllowed(); } catch (err) { return; }
  const next = {
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
    analytics_storage: analytics ? 'granted' : 'denied',
  };
  const changed = Object.keys(next).some((k) => next[k] !== consent[k]) || !consent.decided;
  Object.assign(consent, next, { decided: true });
  if (!changed) return;
  if (useGtag) window.gtag('consent', 'update', next);
  else dl.push({ event: 'dakol_consent', consent: next });
  if (marketing || analytics) loadGtag();
  d.dispatchEvent(new CustomEvent('dakol:consent', { detail: { ...next } }));
}
function bindConsent() {
  const ready = () => applyConsent(window.Shopify?.customerPrivacy);
  d.addEventListener('visitorConsentCollected', ready);
  if (window.Shopify?.customerPrivacy) ready();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) ready(); });
  }
}

/* Pozycje GA4: z atrybutów karty, z JSON strony, z odpowiedzi /cart/add.js. */
function itemFromCard(card, index) {
  const ds = card.dataset;
  const item = {
    item_id: str(ds.itemId), item_name: str(ds.itemName), item_brand: str(ds.itemBrand),
    item_category: str(ds.itemCategory), item_category2: str(ds.itemCategory2), item_category3: str(ds.itemCategory3),
    price: num(ds.itemPrice), quantity: 1,
  };
  if (index !== undefined) item.index = index;
  return item;
}
function categoriesFor(productId) {
  if (cfg.item && String(cfg.item.product_id) === String(productId)) return cfg.item;
  const card = d.querySelector(`[data-product-id="${productId}"][data-item-category]`);
  return card ? itemFromCard(card) : {};
}
function itemFromCartJson(line) {
  const cats = categoriesFor(line.product_id);
  return {
    item_id: str(line.id || line.variant_id), item_name: str(line.product_title || line.title), item_brand: str(line.vendor),
    item_variant: line.variant_title ? str(line.variant_title) : undefined,
    item_category: cats.item_category, item_category2: cats.item_category2, item_category3: cats.item_category3,
    price: num((line.final_price ?? line.price ?? 0) / 100), quantity: Number(line.quantity) || 1,
  };
}
const stripInternal = (item) => { const { product_id, ...rest } = item; return rest; };
const value = (items) => num(items.reduce((s, i) => s + (i.price || 0) * (i.quantity || 1), 0));

/* view_item: karta produktu. */
if (cfg.item) send('view_item', { currency: currency(), value: num(cfg.item.price), items: [stripInternal(cfg.item)] });

/* search: strona wyników (search.performed). */
if (cfg.search && cfg.search.search_term) send('search', { search_term: str(cfg.search.search_term), results_count: Number(cfg.search.results_count) || 0 });

/* view_item_list: każdy kontener [data-item-list] z kartami data-item-id; po filtrach lista jest wysyłana ponownie. */
const sentLists = new Set();
function viewLists(force) {
  d.querySelectorAll('[data-item-list]').forEach((list) => {
    const cards = [...list.querySelectorAll('[data-item-id]')].slice(0, 50);
    if (!cards.length) return;
    const id = list.dataset.itemList;
    const key = `${id}:${cards.map((c) => c.dataset.itemId).join(',')}`;
    if (!force && sentLists.has(key)) return;
    sentLists.add(key);
    send('view_item_list', { item_list_id: str(id), item_list_name: str(list.dataset.itemListName || id), items: cards.map((c, i) => itemFromCard(c, i + 1)) });
  });
}
viewLists();
d.addEventListener('dakol_filter_applied', () => setTimeout(() => viewLists(true), 0));
d.addEventListener('dakol_filter_cleared', () => setTimeout(() => viewLists(true), 0));

/* add_to_cart: odpowiedź /cart/add.js (jedna pozycja albo items[]) z product-form, kalkulatora i asystenta. */
d.addEventListener('dakol:cart:add', (e) => {
  const res = e.detail?.response || {};
  const lines = Array.isArray(res.items) ? res.items : (res.id ? [res] : []);
  if (!lines.length) return;
  const items = lines.map(itemFromCartJson);
  send('add_to_cart', { currency: currency(), value: value(items), items, source: str(e.detail?.source) });
});

/* begin_checkout: przycisk "Do kasy" w koszyku bocznym i na stronie koszyka, dane z JSON [data-pomiar-cart]. */
d.addEventListener('click', (e) => {
  const btn = e.target.closest('button[name="checkout"], a[href$="/checkout"]');
  if (!btn) return;
  const scope = btn.closest('cart-drawer, cart-line, main') || d;
  const node = scope.querySelector('[data-pomiar-cart]') || d.querySelector('[data-pomiar-cart]');
  let cart = null;
  try { cart = JSON.parse(node?.textContent || 'null'); } catch (err) { cart = null; }
  if (!cart || !cart.items || !cart.items.length) return;
  send('begin_checkout', { currency: currency(), value: num(cart.value), items: cart.items.map(stripInternal) });
}, true);

/* 1b. Zdarzenia własne motywu (słownik pkt 8) i asystenta: most z window.dakolEvent do dataLayer.
   add_to_cart z asystenta pomijamy, bo dakol:cart:add niesie pełne pozycje. */
d.addEventListener('dakol:event', (e) => {
  const { name, data } = e.detail || {};
  if (!name || name === 'add_to_cart') return;
  const params = {};
  Object.keys(data || {}).forEach((k) => {
    const v = data[k];
    params[k.slice(0, 40)] = Array.isArray(v) ? str(v.join(',')) : (typeof v === 'object' && v !== null ? str(JSON.stringify(v)) : (typeof v === 'number' ? v : str(v)));
  });
  if (name === 'generate_lead') { params.currency = currency(); params.value = num(params.value || 0); }
  send(name, params);
});

bindConsent();
window.dakolPomiar = { log, consent, send, config: cfg, gtagLoaded: () => gtagLoaded };
export { send, applyConsent, itemFromCartJson, viewLists };
